import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover-supported:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover-supported:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover-supported:bg-destructive/80",
        outline: "text-foreground",
        neutral:
          "border-transparent bg-foreground text-background hover-supported:bg-foreground/80",
        beta: "border-primary/80 bg-primary/20 text-primary font-normal px-2 py-0",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

const Badge = React.forwardRef<HTMLDivElement, BadgeProps>(
  ({ className, variant, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(badgeVariants({ variant }), className)}
        {...props}
      />
    );
  },
);
Badge.displayName = "Badge";

export { Badge, badgeVariants };
